import { render, staticRenderFns } from "./PublicationAttachmentVideos.vue?vue&type=template&id=3e996741"
import script from "./PublicationAttachmentVideos.vue?vue&type=script&lang=js"
export * from "./PublicationAttachmentVideos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports